import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const DEFAULTS = {
  brand_name: "Smart Farmland Invest",
  logo_url: "/logo.png",
  banner_image_opacity: 100,
  email: "invest@smartfarmland.com",
  phone: "+90 212 123 45 67",
  whatsapp: "902121234567",
  address: "İstanbul, Türkiye",
  map_query: "Istanbul,Turkey",
  instagram: "",
  facebook: "",
  linkedin: "",
  twitter: "",
};

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(() => {
    api.get("/settings").then((r) => setSettings({ ...DEFAULTS, ...r.data })).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) return { settings: DEFAULTS, refresh: () => {}, setSettings: () => {} };
  return ctx;
};
